import { Button, Typography } from 'antd';
import React, { ReactElement } from 'react';
import Layout from './Layout';

export default function LoansExport(): ReactElement {
    return (
        <Layout section='loans-export'>
            <Typography.Title level={2}>Loans Export</Typography.Title>
            <Button
                href={`${process.env.API_HOST}/loans/download-report`}
                target='_blank'
                type='primary'
            >Download</Button>
        </Layout>
    );
}
